import React, { useEffect } from 'react';

declare global {
  interface Window {
    adsbygoogle: any;
  }
}

const AdComponent: React.FC = () => {
  useEffect(() => {
    // The "availableWidth=0" error occurs when the AdSense script executes
    // before the ad container has a measurable width. This is a common race
    // condition in SPAs. Wrapping the call in a setTimeout defers its execution
    // until after the current JavaScript event loop has finished and the browser
    // has had a chance to render the component and calculate its layout.
    const timeoutId = setTimeout(() => {
      try {
        if (window.adsbygoogle) {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        }
      } catch (e) {
        console.error("AdSense error:", e);
      }
    }, 100); // A 100ms delay is generally sufficient to ensure rendering.

    // Cleanup the timeout if the component unmounts before it fires.
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div className="my-8 text-center bg-gray-100 p-4 rounded-lg border border-dashed border-gray-300 min-h-[100px] flex flex-col justify-center items-center">
      {/* This is a responsive ad unit, make sure to replace placeholders */}
      <ins className="adsbygoogle"
           // Adding width: '100%' helps the responsive ad unit understand its container size.
           style={{ display: 'block', width: '100%' }}
           data-ad-client="YOUR_ADSENSE_CLIENT_ID" 
           data-ad-slot="YOUR_AD_SLOT_ID"
           data-ad-format="auto"
           data-full-width-responsive="true"></ins>
      <p className="text-xs text-gray-400 mt-2">Advertisement</p>
    </div>
  );
};

export default AdComponent;